import { render, staticRenderFns } from "./PreviewPdf.vue?vue&type=template&id=0945b28e&scoped=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=js"
export * from "./PreviewPdf.vue?vue&type=script&lang=js"
import style0 from "./PreviewPdf.vue?vue&type=style&index=0&id=0945b28e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945b28e",
  null
  
)

export default component.exports